import React, { useState, useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Settings from "./Pages/Settings";
import Buttons from "./Pages/Buttons";
import RelatedList from "./Pages/RelatedList";
import CustomAction from "./Pages/CustomAction";
import "./App.css";
import Wizards from "./Pages/Wizards";

const router = createBrowserRouter([
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/relatedlist",
    element: <RelatedList />,
  },
  {
    path: "/buttons",
    element: <Buttons />,
  },
  {
    path: "/wizards",
    element: <Wizards />,
  },
  {
    path: "/customaction",
    element: <CustomAction />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
